import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { AnalyzerDish, UpdateAnalyzerDishDto } from 'types';

export const updateAnalyzerDish = ({
  data,
  analyzerDishId,
}: {
  data: UpdateAnalyzerDishDto;
  analyzerDishId: number;
}): Promise<AnalyzerDish> => {
  return axios.put(`/api/dishes/connections/${analyzerDishId}`, data);
};

type UseUpdateAnalyzerDishOptions = {
  config?: MutationConfig<typeof updateAnalyzerDish>;
};

export const useUpdateAnalyzerDish = ({
  config,
}: UseUpdateAnalyzerDishOptions) => {
  return useMutation({
    onMutate: async (updatingAnalyzerDish) => {
      await queryClient.cancelQueries(['analyzerDish']);

      const previousAnalyzerDishes = queryClient.getQueryData<AnalyzerDish[]>([
        'analyzerDish',
      ]);

      queryClient.setQueryData(['analyzerDish'], {
        ...previousAnalyzerDishes,
        ...updatingAnalyzerDish.data,
        id: updatingAnalyzerDish.analyzerDishId,
      });

      return previousAnalyzerDishes;
    },
    onError: (_, __, context: any) => {
      if (context?.previousAnalyzerDishes) {
        queryClient.setQueryData(
          ['analyzerDish'],
          context.previousAnalyzerDishes
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['analyzerDish']);
      queryClient.invalidateQueries(['dishes']);
      queryClient.invalidateQueries(['locations']);
    },
    ...config,
    mutationFn: updateAnalyzerDish,
  });
};
